export enum StatusProcesso {
  Aberto,
  Oficio,
  Fechado,
  AguardandoSentenca,
  AguardandoAudiencia
}
